<script setup>
  const lang = useI18n().locale.value
  const router = useRouter()
  const gotoDetail = () => {

    if (lang === 'cn') {
      router.push(`/wantai`)
    } else {
      router.push(`/hk/wantai`)


    }
}

</script>

<template>
  <div ml="8%">
    <div w="95%" mt-24 mb-24>
      <div class="about-warp__right--title">
      {{ $t('zlhb') }}
    </div>
    <div class="about-warp__right--content partner-box">
      <ul class="box-partners">
        <li>
          <!-- <img src="https://fdfw-oss.fdzq.com/user_info_test/202109021456528884.png"> -->
          <img style="width: 125px;height: auto;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636336129-zdzmoa.png">
          <p>{{ $t('hxjjxg') }}</p>
        </li>
        <li>
          <img style="width: 125px;height: auto;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636016086-c9ftgd.png">
          <p>{{ $t('gtgj') }}</p>
        </li>
        <li>
          <img style="width: 120px;height: auto;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636338738-0zadls.png">
          <p>{{ $t('nfdy') }}</p>
        </li>
        <li>
          <img style="width: 110px;height: auto;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636338792-jq3h2e.png">
          <p>{{ $t('ztcj') }}</p>
        </li>
        <li>
          <img style="width: 110px;height: auto;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636338836-3a551y.png">
          <p>{{ $t('jljyb') }}</p>
        </li>
        <li>
          <img  src="https://imgoss.fdzq.com/go_fd_co/fd-1636338883-zf5uql.png">
          <p>{{ $t('tbkj') }}</p>
        </li>
        <li>
          <img src="https://imgoss.fdzq.com/go_fd_co/fd-1636338934-130ift.png">
          <p>{{ $t('cls') }}</p>
        </li>
        <li>
          <img class="mt5" style="width: 110px;height: auto;" src="https://imgoss.fdzq.com/go_fd_co/fd-1636338963-i4oj1d.png">
          <p>{{ $t('jmxw') }}</p>
        </li>
        <li>
          <img style="width: 75px;height: auto;"  src="https://imgoss.fdzq.com/go_fd_co/fd-1636339006-da1m93.png">
          <p>{{ $t('jjttxs') }}</p>
        </li>
        <li>
          <p class="logo-title">信报</p>
          <p>{{ $t('xbcjxw') }}</p>
        </li>
        <li @click="gotoDetail()">
          <img style="width: 110px;height: auto;"  src="https://imgoss.techfx88.com/www_img/www_upload/default17252551086583.png">
          <p>{{ $t('wcsxt') }}</p>
        </li>
      </ul>
      <div class="tips">
        <p>{{ $t('xxpl') }}
          <br>{{ $t('yshzhbtgdsjbfyfdcpdgdfdcpgnjyytgxxbnyzxkhtjgrzhhrhqtzhzgmhcsrhzqcpdjy') }}
        </p>
        <p>
          {{ $t('sytzdsjfxgqdzqhjrcpdbxbbnbzwldjghhbqjzsrtzdyhknyzyfsfxdzdmdscztbnbzylhfzssdntzzqhqtjrcpszhyksdknxtzzztzqyzxkltzmbhfx') }}
        </p>
        <p>
          {{ $t('bxxsyzldlybrwskkddfdzqbbzqzqxhwzxfdzqbbdsybxxsbhdclcsdrhzjhjjsshycygdqtsscdrhzrbxxtjdrhzqjknhyzddfxknbybmyjbsysytzzbxxstjdzqhjrgjdjgjzjsyknhshlyxebdgwdyjbbndbwldbx') }}
        </p>
      </div>

    </div>
    </div>

  </div>
</template>
<style lang="less" scoped>
@import "../../assets/less/main.less";
@import "../assets/css/about.less";
@media screen and (max-width: 420px) {
  body {
    .partner-box {
      padding-top: 20px!important;
      .box-partners {
        padding-bottom: 20px;
        display: grid;
        grid-gap: 30px;
        grid-template-columns:repeat(2, 1fr);
        grid-template-rows: repeat(3, 1fr);
        li {
          width: auto;
          height: auto;
          margin: 0;
          bottom: 0;


        }
      }
      .tips {
        width: 100%;
        p {
          width: 100%;
          word-wrap:break-word;

          word-break:normal;
        }

      }
    }
  }
}

.partner-box {
  padding-top: 55px !important;

  .data-title {
    font-size: 14px;
    color: #0D0E14;
    line-height: 20px;
    padding-bottom: 30px;
  }

  .box-partners {
    margin-bottom: 10px;
    display: flex;
    flex-wrap: wrap;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 55px;
      margin-right: 100px;
      width: 130px;
      text-align: center;
      .font-size-line(14, 20);
      color: #61676B;
      img {
        vertical-align: top;
        // width: 150px;
        height: 32px;
        margin-bottom: 15px;
        &.mt5{
          margin-top: 5px;
        }
      }

      span {
        font-size: 16px;
        color: #61676B;
      }

      .logo-title{
        margin-bottom: 15px;
        font-size: 21px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 29px;
      }
    }
  }

  .tips {
    padding-bottom: 40px;

    p {
      // width: 680px;
      .font-size-line(12, 20);
      color: #61676B;
      margin-bottom: 5px;
    }
  }

}
</style>
